// @flow
import type { DataField } from "../../lib/Types";
import React from "react";
import styled, { css } from "styled-components";
import DropDown from "../../DropDown";
import type { DropDownItem } from "../../DropDown";
import { observer } from "mobx-react";

const Select = styled.select`
  min-width: 80px;
  max-width: 130px;
  border-right: 1px solid #ddd;
  border: 0px;
  border-right: 1px solid #ccc;
  &:focus {
    background-color: #f4f4f4;
  }
  ${props =>
    props.required &&
    !props.value &&
    css`
      background-color: #ffbbbb;
    `};
  ${props =>
    (!props.required || props.value) &&
    css`
      background-color: white;
    `};
  ${props =>
    !props.fullWidth &&
    css`
      height: 26px;
    `};
  ${props =>
    props.fullWidth &&
    css`
      width: 90%;
      border: 1px solid #ddd;
      padding: 10px;
    `};
  ${props =>
    props.highlighted &&
    css`
      background-color: #ecffa4;
      color: #ecffa4;
    `};
`;
type Props = {
  data_field: DataField,
  fullWidth: boolean,
  onFocus: Function,
  copyDown: Function,
  gridCol: ?string,
};

class FixedDropDown extends React.Component<Props> {
  updateValue = event => (this.props.data_field.value = event.target.value);

  _handleKeyDown = e => {
    const { onCtrlDown, onCtrlUp } = this.props;
    if (e.ctrlKey && e.keyCode === 68) {
      console.log("Ctrl + Down pressed");
      onCtrlDown && onCtrlDown();
      e.preventDefault();
    }
  };

  render() {
    const {
      fullWidth,
      data_field: { value, mandatory, items, highlighted },
      onFocus,
      gridCol,
    } = this.props;
    return (
      <Select
        value={value || ""}
        onChange={this.updateValue}
        required={mandatory}
        fullWidth={fullWidth}
        highlighted={highlighted}
        onFocus={onFocus}
        style={{ flex: 1 }}
        onKeyDown={this._handleKeyDown}
        data-sample-grid-col={gridCol}
      >
        <option value="">Select..</option>
        {items.map((item, i) => (
          <option key={i}>{item}</option>
        ))}
      </Select>
    );
  }
}

export default observer(FixedDropDown);
